import { useState } from "react";

export type CatalogViewMode = "list" | "grid";

/**
 * Custom hook holding the grid/list view-mode state for inventory catalog pages.
 * @param {CatalogViewMode} [initial] - Initial view mode. Defaults to "grid".
 */
export const useCatalogViewMode = (initial: CatalogViewMode = "grid") => {
  const [viewMode, setViewMode] = useState<CatalogViewMode>(initial);
  return { viewMode, setViewMode };
};
